import { CartActionType, trackUserAction } from '../../UserActionsManager'
import { CartEventsData, EventFilter } from '../types/events'
import { BaseProvider } from './base'

export class CartEventsProvider implements BaseProvider {
  public eventFilter?: EventFilter

  constructor(eventFilter?: EventFilter) {
    this.eventFilter = eventFilter
  }

  initialize(): void {
    // Nothing to initialize for this provider
  }

  public setGlobalContext(): void {
    // No global context needed for cart events
  }

  public clearGlobalContext(_keys?: string[]): void {
    // No global context to clear for cart events
  }

  // eslint-disable-next-line @typescript-eslint/require-await
  public async trackEvent(
    eventName: string,
    cartEventsData: CartEventsData
  ): Promise<void> {
    if (typeof window === 'undefined') {
      return
    }
    try {
      if (eventName === CartActionType.cartDelete.toString()) {
        trackUserAction(CartActionType.cartDelete, cartEventsData.parts)
      }
      if (eventName === CartActionType.cartItemDelete.toString()) {
        trackUserAction(CartActionType.cartItemDelete, cartEventsData.parts)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to track cart event:', error)
    }
  }
}
